import correct from '@/assets/img/documents/cost-estimate.jpg';
import wrong from '@/assets/img/documents/cost-estimate-wrong.jpg';
import Card from '@/components/Card';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';
import { isInsurersEstimateIncomplete } from '@/features/v2/vehicle-damage/utils/insurersEstimateRule';

import { useLingui } from '@lingui/react';

export const INSURERS_ESTIMATE_NAME = 'insurers_estimate';

const InsurersEstimate = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać kosztorys ubezpieczyciela?'),
    steps: [
      i18n.t('Upewnij się, że wszystkie dane pojazdu są widoczne.'),
      i18n.t('Sprawdź, czy załączasz wszystkie strony kosztorysu.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
      i18n.t('Jeśli plik jest zabezpieczony – dołącz hasło.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  const hint = {
    title: i18n.t('Sprawdź, czy załączasz wszystkie strony kosztorysu'),
    description: i18n.t(
      'Sprawdź numerację w stopce dokumentu (np. "str. 1 z 3") i dołącz wszystkie strony, łącznie z uzasadnieniem i wyliczoną kwotą. Brakująca strona to najczęstsza przyczyna opóźnienia analizy Twojej sprawy.'
    ),
  };

  return (
    <Card>
      <Uploader
        title={i18n.t('Kosztorys ubezpieczyciela')}
        instructionProps={instructionProps}
        inputFieldName={INSURERS_ESTIMATE_NAME}
        required
        attachmentTypeId={ATTACHMENT_TYPES.KOSZTORYS}
        hint={hint}
        extraValidate={(files) =>
          isInsurersEstimateIncomplete(files)
            ? i18n.t('Aby przejść dalej wgraj wszystkie strony kosztorysu')
            : undefined
        }
      />
    </Card>
  );
};

export default InsurersEstimate;
